/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageDto } from '../../models/page-dto';

export interface GetAllRouterTypes$Params {

/**
 * The index of requested page. The first page's index is 0
 */
  page?: number;

/**
 * The requested amount of pages. The amount of total pages depends on this value
 */
  pageSize?: number;
}

export function getAllRouterTypes(http: HttpClient, rootUrl: string, params?: GetAllRouterTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDto>> {
  const rb = new RequestBuilder(rootUrl, getAllRouterTypes.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageDto>;
    })
  );
}

getAllRouterTypes.PATH = '/routers/type';
